import { render, staticRenderFns } from "./TopicoTexto.vue?vue&type=template&id=41818d6a&scoped=true&"
import script from "./TopicoTexto.vue?vue&type=script&lang=js&"
export * from "./TopicoTexto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41818d6a",
  null
  
)

export default component.exports